import { render, staticRenderFns } from "./ExchangeDetail.vue?vue&type=template&id=1730f9f9&scoped=true"
import script from "./ExchangeDetail.vue?vue&type=script&lang=js"
export * from "./ExchangeDetail.vue?vue&type=script&lang=js"
import style0 from "./ExchangeDetail.vue?vue&type=style&index=0&id=1730f9f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1730f9f9",
  null
  
)

export default component.exports